/**
 * Mobile Touch Enhancements for Sleepy Sloth Theme
 * Handles swipe gestures for product galleries and carousels
 */

(function() {
  'use strict';

  // Configuration
  const MOBILE_BREAKPOINT = 767; // px - matches CSS mobile breakpoint
  const SWIPE_THRESHOLD = 50; // px - minimum swipe distance to trigger action

  // ===== Product Gallery Swipe =====
  function initProductGallerySwipe() {
    const gallery = document.querySelector('.ss-product-gallery__main');
    if (!gallery) return;

    const thumbnails = document.querySelectorAll('.ss-product-gallery__thumbnail');
    if (thumbnails.length <= 1) return;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTime = 0;
    let velocity = 0;
    let isZoomed = false;

    // Track zoom state to disable swipe when zoomed
    function updateZoomState() {
      const zoomOverlay = document.querySelector('.ss-product-gallery__zoom-overlay');
      isZoomed = zoomOverlay && zoomOverlay.classList.contains('active');
    }

    // Listen for zoom state changes
    const zoomOverlay = document.querySelector('.ss-product-gallery__zoom-overlay');
    if (zoomOverlay) {
      const observer = new MutationObserver(updateZoomState);
      observer.observe(zoomOverlay, { attributes: true, attributeFilter: ['class'] });
    }

    function getCurrentIndex() {
      const index = Array.from(thumbnails).findIndex(thumb => thumb.classList.contains('active'));
      return index >= 0 ? index : 0;
    }

    function navigateToImage(newIndex) {
      if (newIndex >= 0 && newIndex < thumbnails.length) {
        thumbnails[newIndex].click();
      }
    }

    function handleTouchStart(e) {
      if (window.innerWidth > MOBILE_BREAKPOINT || isZoomed) return; // Only on mobile and when not zoomed
      
      isDragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      currentX = startX;
      startTime = Date.now();
      velocity = 0;
    }

    function handleTouchMove(e) {
      if (!isDragging || window.innerWidth > MOBILE_BREAKPOINT || isZoomed) return;
      
      const newX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaTime = Date.now() - startTime;
      
      // Calculate velocity for momentum
      if (deltaTime > 0) {
        velocity = (newX - currentX) / deltaTime;
      }
      
      currentX = newX;
    }

    function handleTouchEnd() {
      if (!isDragging || window.innerWidth > MOBILE_BREAKPOINT || isZoomed) return;
      
      isDragging = false;
      const diff = startX - currentX;
      const swipeTime = Date.now() - startTime;

      // Consider both distance and velocity for a more natural feel
      const isQuickSwipe = swipeTime < 300 && Math.abs(velocity) > 0.5;
      const isLongSwipe = Math.abs(diff) > SWIPE_THRESHOLD;

      if (isQuickSwipe || isLongSwipe) {
        const currentIndex = getCurrentIndex();
        if (diff > 0) {
          // Swiped left - next image
          navigateToImage(currentIndex + 1);
        } else {
          // Swiped right - previous image
          navigateToImage(currentIndex - 1);
        }
      }
    }

    gallery.addEventListener('touchstart', handleTouchStart, { passive: true });
    gallery.addEventListener('touchmove', handleTouchMove, { passive: true });
    gallery.addEventListener('touchend', handleTouchEnd);
  }

  // ===== Sticky Add to Cart =====
  function initStickyAddToCart() {
    const productPage = document.querySelector('.ss-product-main');
    if (!productPage) return;

    const mainAddToCart = document.querySelector('.ss-add-to-cart:not(.ss-sticky-add-to-cart__button)');
    if (!mainAddToCart) return;

    // Create sticky bar
    const stickyBar = document.createElement('div');
    stickyBar.className = 'ss-sticky-add-to-cart';
    
    // Safely get text content to prevent XSS
    const productTitle = document.querySelector('.ss-product-info__title');
    const productPrice = document.querySelector('.ss-product-info__price-current');
    
    const stickyContent = document.createElement('div');
    stickyContent.className = 'ss-sticky-add-to-cart__content';
    
    const infoDiv = document.createElement('div');
    infoDiv.className = 'ss-sticky-add-to-cart__info';
    
    const titleDiv = document.createElement('div');
    titleDiv.className = 'ss-sticky-add-to-cart__title';
    titleDiv.textContent = productTitle ? productTitle.textContent : 'Product';
    
    const priceDiv = document.createElement('div');
    priceDiv.className = 'ss-sticky-add-to-cart__price';
    priceDiv.textContent = productPrice ? productPrice.textContent : '';
    
    infoDiv.appendChild(titleDiv);
    infoDiv.appendChild(priceDiv);
    
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ss-btn ss-btn--primary ss-sticky-add-to-cart__button';
    button.textContent = mainAddToCart.textContent.trim();
    
    stickyContent.appendChild(infoDiv);
    stickyContent.appendChild(button);
    stickyBar.appendChild(stickyContent);

    document.body.appendChild(stickyBar);

    const stickyButton = button;
    const mobileNav = document.querySelector('.ss-mobile-bottom-nav');

    function updateMobileNavOffset() {
      const navOffset = mobileNav && window.getComputedStyle(mobileNav).display !== 'none'
        ? Math.ceil(mobileNav.getBoundingClientRect().height)
        : 0;
      stickyBar.style.setProperty('--ss-mobile-nav-offset', navOffset + 'px');
    }

    const mobileNavObserver = mobileNav && window.ResizeObserver
      ? new ResizeObserver(updateMobileNavOffset)
      : null;
    if (mobileNavObserver) mobileNavObserver.observe(mobileNav);

    // Show/hide sticky bar based on scroll position
    let lastScroll = 0;
    let ticking = false;

    function updateStickyBar() {
      const mainButtonRect = mainAddToCart.getBoundingClientRect();
      const header = document.getElementById('header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      
      // Only show after the original purchase action has passed above the viewport.
      if (mainButtonRect.bottom <= headerBottom && !stickyBar.hidden) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
      
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateStickyBar);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });

    // Handle sticky button click
    stickyButton.addEventListener('click', function() {
      mainAddToCart.click();
    });

    function syncStickyButton() {
      stickyButton.disabled = mainAddToCart.disabled;
      stickyButton.textContent = mainAddToCart.textContent.trim();
      stickyButton.setAttribute('aria-disabled', String(mainAddToCart.disabled));
      priceDiv.textContent = productPrice ? productPrice.textContent.trim() : '';
      stickyBar.hidden = window.getComputedStyle(mainAddToCart).display === 'none';
      if (stickyBar.hidden) stickyBar.classList.remove('visible');
      requestTick();
    }

    // Update button state when main button changes
    const observer = new MutationObserver(function(mutations) {
      if (mutations.length > 0) syncStickyButton();
    });

    observer.observe(mainAddToCart, { attributes: true, childList: true, characterData: true, subtree: true });

    const priceObserver = productPrice
      ? new MutationObserver(syncStickyButton)
      : null;
    if (priceObserver) {
      priceObserver.observe(productPrice, { childList: true, characterData: true, subtree: true });
    }

    // Initial check
    updateMobileNavOffset();
    syncStickyButton();
    requestTick();
  }

  // ===== Horizontal Scroll Enhancements =====
  function initHorizontalScrollEnhancements() {
    const scrollContainers = document.querySelectorAll('.ss-collections-grid--swipeable, .ss-new-in-grid--swipeable');
    
    scrollContainers.forEach(container => {
      if (!container) return;

      // Smooth momentum scrolling
      let isDown = false;
      let startX;
      let scrollLeft;
      let velocity = 0;
      let lastX = 0;
      let lastTimestamp = 0;

      container.addEventListener('mousedown', (e) => {
        if (window.innerWidth > MOBILE_BREAKPOINT) return;
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        velocity = 0;
        lastX = e.pageX;
        lastTimestamp = Date.now();
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;

        // Calculate velocity
        const now = Date.now();
        const dt = now - lastTimestamp;
        if (dt > 0) {
          velocity = (e.pageX - lastX) / dt;
        }
        lastX = e.pageX;
        lastTimestamp = now;
      });
    });
  }

  // ===== Mobile Filter Improvements =====
  function initMobileFilters() {
    const filterToggle = document.querySelector('.ss-filters-toggle');
    const filterPanel = document.querySelector('.ss-filters--mobile');
    const filterClose = document.querySelector('.ss-filters__close');
    
    if (!filterToggle || !filterPanel) return;

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'ss-mobile-overlay';
    document.body.appendChild(overlay);

    function openFilters() {
      filterPanel.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('scroll-lock');
    }

    function closeFilters() {
      filterPanel.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('scroll-lock');
    }

    filterToggle.addEventListener('click', openFilters);
    
    if (filterClose) {
      filterClose.addEventListener('click', closeFilters);
    }
    
    overlay.addEventListener('click', closeFilters);

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterPanel.classList.contains('active')) {
        closeFilters();
      }
    });
  }

  // ===== Initialize all mobile features =====
  function init() {
    // Only run on mobile or when needed
    if ('ontouchstart' in window || window.innerWidth <= MOBILE_BREAKPOINT) {
      initProductGallerySwipe();
      initHorizontalScrollEnhancements();
    }

    // These run on all devices but adjust behavior based on viewport
    initStickyAddToCart();
    initMobileFilters();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', init);

})();
